module.exports = __webpack_public_path__ + "img/fend-logo.e5fc4a9e.png";